import { Link } from "react-router-dom";
import { Mail, MapPin, Building, Shield } from "lucide-react";

function DeleteAccountPage({ user, onLogout }) {
  return (
    <div className="min-h-screen bg-gradient-to-b from-yellow-50 to-white py-12 px-4">
      <div className="max-w-2xl mx-auto">
        {/* Header */}
        <div className="text-center mb-8">
          <img 
            src="/assets/lsbp-logo.png" 
            alt="Lemonade Stand Business Plan"
            className="mx-auto mb-6"
            style={{ maxWidth: "120px", height: "auto" }}
          />
          <h1 className="text-3xl font-bold text-gray-800 mb-2">
            Delete Account and Data Request
          </h1>
          <p className="text-gray-600">Lemonade Stand Business Plan</p>
        </div>

        {/* Main Content Card */}
        <div className="bg-white rounded-2xl shadow-xl p-8 mb-8">
          <p className="text-gray-700 mb-8 text-lg leading-relaxed">
            Lemonade Stand Business Plan allows users, parents, and guardians to request deletion of an account and associated data at any time.
          </p>

          {/* How to Request Section */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-gray-800 mb-4 flex items-center gap-2">
              <Mail className="w-5 h-5 text-yellow-600" />
              How to Request Account Deletion
            </h2>
            <p className="text-gray-700 mb-4">
              To request deletion of your account and associated data, please email:
            </p>
            <a 
              href="mailto:support@lemonadestandbusinessplan.com?subject=Delete%20My%20Account"
              className="inline-block bg-yellow-100 text-yellow-800 font-semibold px-4 py-2 rounded-lg hover:bg-yellow-200 transition-colors mb-4"
            >
              support@lemonadestandbusinessplan.com
            </a>
            
            <p className="text-gray-700 mb-2"><strong>Subject line:</strong></p>
            <p className="text-gray-600 bg-gray-50 px-4 py-2 rounded-lg mb-4 font-mono">
              Delete My Account
            </p>

            <p className="text-gray-700 mb-2"><strong>Please include:</strong></p>
            <ul className="list-disc list-inside text-gray-600 space-y-1 ml-2">
              <li>The email address associated with the account</li>
              <li>The name of the user or student</li>
              <li>Confirmation that you are the account holder or parent/guardian</li>
            </ul>
          </section>

          {/* What Data Is Deleted Section */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-gray-800 mb-4 flex items-center gap-2">
              <Shield className="w-5 h-5 text-yellow-600" />
              What Data Is Deleted
            </h2>
            <p className="text-gray-700 mb-4">
              When an account deletion request is processed, we permanently delete:
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-1 ml-2">
              <li>Account login credentials</li>
              <li>User name or nickname</li>
              <li>Learning progress and activity data</li>
              <li>Stored preferences linked to the account</li>
            </ul>
          </section>

          {/* Data Retention Section */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-gray-800 mb-4">
              Data Retention
            </h2>
            <p className="text-gray-600 leading-relaxed">
              Some limited data may be retained for up to 30 days for legal, security, or compliance purposes. Retained data is not used for marketing and is not shared with third parties.
            </p>
          </section>

          {/* Contact Section */}
          <section className="border-t border-gray-200 pt-8">
            <h2 className="text-xl font-bold text-gray-800 mb-4 flex items-center gap-2">
              <Building className="w-5 h-5 text-yellow-600" />
              Contact
            </h2>
            <div className="text-gray-600 space-y-2">
              <p className="font-semibold text-gray-800">Lemonade Stand Business Plan</p>
              <p className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-1 flex-shrink-0" />
                <span>112 South Water Street #120<br />Henderson NV 89015</span>
              </p>
              <p className="flex items-center gap-2">
                <Mail className="w-4 h-4 flex-shrink-0" />
                <a 
                  href="mailto:info@thewementality.org"
                  className="text-yellow-600 hover:text-yellow-700 hover:underline"
                >
                  info@thewementality.org
                </a>
              </p>
            </div>
          </section>
        </div>

        {/* Back to Home */}
        <div className="text-center">
          <Link 
            to="/" 
            className="text-gray-500 hover:text-gray-700 text-sm"
          >
            ← Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}

export default DeleteAccountPage;
